export const jobTypes = [
  { label: "Full time", value: "full_time" },
  { label: "Freelance", value: "freelancer" },
  { label: "Open to both", value: "open_to_both" },
];

export const commanRoleOptions = [
  {
    label: "Coach",
    value: "COACH",
  },
  {
    label: "Freelancer",
    value: "OPEN_TALENT",
  },
  {
    label: "Hire Talent",
    value: "HIRE_TALENT",
  },
];

export const StatusDefinitions = {
  resourceContent: {
    Draft: { value: "Draft", color: "ct_draft_badge" },
    Published: { value: "Published", color: "ct_publish_badge" },
    Archived: { value: "Archived", color: "ct_combined_badge" },
    Restricted: { value: "Restricted", color: "ct_draft_badge" },
  },
  jobPostContent: {
    Draft: { value: "Draft", color: "ct_draft_badge" },
    Active: { value: "Active", color: "ct_publish_badge" },
    Open: { value: "Open", color: "ct_draft_badge" },
  },
  projectContent: {
    inreview: { value: "Inreview", color: "ct_publish_badge" },
    active: { value: "Active", color: "ct_publish_badge" },
    completed: { value: "Completed", color: "ct_draft_badge" },
    dismissed: { value: "Dismissed", color: "ct_draft_badge" },
  },
  assignTo: {
    invited: {
      value: "Invited",
      style: {
        backgroundColor: "hsl(43deg 100% 51% / 10%)",
        borderColor: "var(--yellow)",
      },
      color: "ct_yellow_text",
    },
    accepted: {
      value: "Accepted",
      style: {
        backgroundColor: "hsl(199deg 64% 73% / 10%)",
        borderColor: "#8ECAE6",
      },
      color: "ct_sky_blue_text",
    },
    on_going: {
      value: "On Going",
      style: {
        backgroundColor: "hsl(199deg 64% 73% / 10%)",
        borderColor: "#8ECAE6",
      },
      color: "ct_sky_blue_text",
    },
    todo: {
      value: "To Do",
      style: {
        backgroundColor: "hsl(199deg 64% 73% / 10%)",
        borderColor: "#8ECAE6",
      },
      color: "ct_sky_blue_text",
    },
    completed: {
      value: "Completed",
      style: {
        backgroundColor: "hsl(199deg 64% 73% / 10%)",
        borderColor: "#8ECAE6",
      },
      color: "ct_sky_blue_text",
    },
    rejected: {
      value: "Rejected",
      style: {
        backgroundColor: "hsl(32deg 100% 49% / 10%)",
        borderColor: "var(--orange)",
      },
      color: "ct_orange_text",
    },
  },
};

export const projectStatus = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Review",
    value: "inreview",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Dismissed",
    value: "dismissed",
  },
];

export const freelancerStatus = [
  {
    label: "In Review",
    value: "inreview",
  },
  {
    label: "To do",
    value: "todo",
  },
  {
    label: "On Going",
    value: "ongoing",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];

export const getStatusLabel = (status) =>
  projectStatus.find((item) => item.value === status)?.label || "#N/A";

export const chatRole = {
  OPEN_TALENT: "Freelancer",
  HIRE_TALENT: "Hire-Talent",
  ADMIN: "Admin",
}